import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Progress } from '../ui/progress';

const ROWS = [
  { key: 'hot_deal',    label: 'Hot Deal',    color: 'text-orange-600' },
  { key: 'sql',         label: 'SQL',         color: 'text-success' },
  { key: 'warm_lead',   label: 'Warm Lead',   color: 'text-amber-600' },
  { key: 'cold_lead',   label: 'Cold Lead',   color: 'text-blue-600' },
  { key: 'disqualified',label: 'Disqualified',color: 'text-destructive' },
];

export default function GradeDistribution({ metrics }) {
  if (!metrics?.grade_breakdown) return null;
  const total = Math.max(metrics.total_calls, 1);

  return (
    <Card className="bg-card border-border/50">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">Deal Grade Distribution</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex gap-4">
          {ROWS.map(({ key, label, color }) => {
            const count = metrics.grade_breakdown[key] || 0;
            return (
              <div key={key} className="flex-1">
                <div className="flex justify-between text-xs mb-1">
                  <span className={color}>{label}</span>
                  <span>{count}</span>
                </div>
                <Progress value={(count / total) * 100} className="h-2" />
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
